
export function getPerson (people){
    return {
        type: 'GET-PERSON',
        payload: people
    }
}
export function getAllPerson (persons){
    return {
        type: 'GET-ALL-PERSONS',
        payload: persons
    }
}
export function addPerson (person){
    return {
        type: 'ADD-PERSON',
        payload: person
    }
}
export function addPayment (payment){
    return {
        type: 'ADD-PAYMENT',
        payload: payment
    }
}
export function getRent (rental){
    return {
        type: 'GET-RENT',
        payload: rental
    }
}




export function getUser(users){
    return {
        type: 'GET-USER',
        payload: users
    }
}
export function selectProfil(id){
    return {
        type : "SELECT-USER",
        payload : id
    }
}
export function setProfil(obj) {
    return {
        type : "SET-USER",
        payload : obj
    }
}
